import { __extends } from "tslib";
import { AbstractionBase } from "@awayjs/core";
/**
 * @class away.partition.EntityNode
 */
var EntityNode = /** @class */ (function (_super) {
    __extends(EntityNode, _super);
    function EntityNode(entity, partition) {
        return _super.call(this, entity, partition) || this;
    }
    Object.defineProperty(EntityNode.prototype, "entity", {
        get: function () {
            return this._asset;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntityNode.prototype, "pickObject", {
        get: function () {
            return this._asset.pickObject;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntityNode.prototype, "boundsVisible", {
        get: function () {
            return this._asset.boundsVisible;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntityNode.prototype, "maskId", {
        /**
         *
         * @returns {number}
         */
        get: function () {
            return this._asset.maskId;
        },
        enumerable: true,
        configurable: true
    });
    EntityNode.prototype.getBoundsPrimitive = function (pickGroup) {
        return this._asset.getBoundsPrimitive(pickGroup);
    };
    /**
     *
     * @returns {boolean}
     */
    EntityNode.prototype.isCastingShadow = function () {
        return this._asset.castsShadows;
    };
    EntityNode.prototype.onClear = function (event) {
        this._pool.clearEntity(this._asset);
        _super.prototype.onClear.call(this, event);
    };
    /**
     *
     * @param planes
     * @param numPlanes
     * @returns {boolean}
     */
    /**
     *
     * @param planes
     * @param numPlanes
     * @returns {boolean}
     */
    EntityNode.prototype.isInFrustum = function (rootEntity, planes, numPlanes, pickGroup) {
        if (!this._asset._iIsVisible())
            return false;
        return true;
        return pickGroup.getAbstraction(this._asset)._isInFrustumInternal(rootEntity, planes, numPlanes);
    };
    EntityNode.prototype.isVisible = function () {
        return this._asset._iIsVisible();
    };
    /**
     * @inheritDoc
     */
    EntityNode.prototype.isIntersectingRay = function (rootEntity, globalRayPosition, globalRayDirection, pickGroup) {
        // if (!(<IPartitionEntity> this._asset).partition)
        // 	return false;
        // var box:Box = pickGroup.getBoundsPicker((<IPartitionEntity> this._asset).partition).getBoxBounds(null, false, true);
        // if (box == null)
        // 	return false;
        // if (box.rayIntersection((<IPartitionEntity> this._asset).transform.inverseConcatenatedMatrix3D.transformVector(globalRayPosition), (<IPartitionEntity> this._asset).transform.inverseConcatenatedMatrix3D.deltaTransformVector(globalRayDirection)) < 0)
        // 	return false;
        return pickGroup.getAbstraction(this._asset)._isIntersectingRayInternal(rootEntity, globalRayPosition, globalRayDirection);
    };
    /**
     *
     * @returns {boolean}
     */
    EntityNode.prototype.isRenderable = function () {
        return this._asset._iAssignedColorTransform()._isRenderable();
    };
    /**
     * @inheritDoc
     */
    EntityNode.prototype.acceptTraverser = function (traverser) {
        if (traverser.enterNode(this))
            traverser.applyEntity(this._asset);
    };
    return EntityNode;
}(AbstractionBase));
export { EntityNode };
